<script>
import catalog from '@/mixins/catalog';
//import VueSlickCarousel from 'vue-slick-carousel';
export default {

  name: 'listing-card-mobile',
  //components: {"vue-slick-carousel": VueSlickCarousel},
  props: ['item'],  
  mixins: [catalog],
  //template: '#location',
  data: function(){

      return {
        offerActive:{},
        settings:{slidesToShow:1,
                                                fade:true,
                                                arrows:false,
                                                lazyLoad: "ondemand",
                                                speed: 250
                                                //asNavFor: this.$refs.slickSmallGallery


                            }
      }
  },    
  methods: {

    setOffer()
    {
        this.item.ID = this.offerActive.ID;
        this.item.NAME = this.offerActive.NAME;
        this.item.FORMAT_PRICE = this.offerActive.FORMAT_PRICE;
        this.item.FORMAT_PRICE_OLD = this.offerActive.FORMAT_PRICE_OLD;
        this.item.PRICE_OLD = this.offerActive.PRICE_OLD;
        this.item.DISCOUNT_PR = this.offerActive.DISCOUNT_PR;
        this.item.DETAIL_PAGE_URL = this.offerActive.DETAIL_PAGE_URL;
        //console.log(this.offerActive);
    },

    hoverControlImage: function(index, photo, item){

        item.GALLERY.forEach(element => {
            
            element.active = false;
        });
        //console.log("навели");
        // console.log(photo);
        this.$set(photo, 'active', true);

        //photo.active = true;
        //console.log(this.$refs);
        this.$refs['slick_'+item.ID].goTo(index);

    },



  }

}



</script>

<template>
    <div class="shop-one-cont-h">         
        <div class="actions" v-if="item.ACTIONS" v-for="ACTION in item.ACTIONS">
                    <div class="item-promo-popular-peop" v-if="ACTION.VALUE=='3547'"></div> 
                    <div class="item-promo-akcii"  v-if="ACTION.VALUE=='3546'"></div> 
                    <div class="item-promo-new"  v-if="ACTION.VALUE=='3545'"></div>
                    <div class="item-promo-xit"  v-if="ACTION.VALUE=='3548'"></div>
                    <div class="item-promo-rent-i"  v-if="ACTION.VALUE=='3549'"></div>
                    <div class="item-promo-del-i"  v-if="ACTION.VALUE=='6070'"></div>
                </div>
            

                <div class="shop-one" >
                            <div class="flex-cont">
                                <a :href="item.DETAIL_PAGE_URL">
                                    <div class="shop-img">
                                            <div class="gallery-one">
                                                    <img :src="item.GALLERY[0].src" :alt="item.NAME" :width="item.GALLERY[0].width" :height="item.GALLERY[0].height" loading="lazy">
                                                </div>

                                            <div class="old-price-block-img old-price-block" v-if="item.PRICE_OLD > 0">
                                                <del class="hide dis-pr-f" v-html="item.FORMAT_PRICE_OLD"></del>  
                                                <div class="dis-pr">-{{item.DISCOUNT_PR}}%</div>
                                            </div> 
                                    </div>
                                </a>
                            </div>
                                <!-- <div class="list-mar-quick">
                                <a class="quick-look-button" href="">
                                    Быстрый просмотр
                                </a>
                            </div> -->
                        <div class="content-list-card">    
                            <div class="shop-name-container">
                                <a :href="item.DETAIL_PAGE_URL" class="shop-name">
                                    {{item.NAME}}
                                </a>
                            
                            </div> 
                        
                            <div class="pos-pr-rel">
                                <div class="price-list" v-html="item.FORMAT_PRICE">
                                
                                </div> 
                                <div class="old-price-block" v-if="item.PRICE_OLD > 0">
                                    <del class="dis-pr-f" v-html="item.FORMAT_PRICE_OLD"></del>  
                                    <div class="dis-pr hide">-{{item.DISCOUNT_PR}}%</div>
                                </div> 
                            </div>
                            
                            <!-- <button @click="addToBasket(item.ID)">В корзину</button> -->

                                <div class="stars" >
                                    <div class="star" v-for="star in 5" :class="{active: getRating(star, item)}"></div>
                                    <div class="count-feed">({{getCountFeed(item)}})</div>
                                </div>

                                <label class='label-variants' v-if="item.CUSTOM_OFFERS.length > 1">Варианты исполнения ({{item.CUSTOM_OFFERS.length}}):</label>
                                <div class="block-variants" v-if="item.CUSTOM_OFFERS.length > 1">
                                    
                                    <div class="link-variant" v-if="item.CUSTOM_OFFERS">
                                        <a :href="offer.DETAIL_PAGE_URL" v-for="(offer, index) in item.CUSTOM_OFFERS" :class="{active:index==0}">
                                            {{offer.PROPS.OFFER_NAME?offer.PROPS.OFFER_NAME[0].VALUE:offer.NAME}}
                                        </a>

                                    </div>
                                </div>
                                <!-- <div class="zag" v-if="item.CUSTOM_OFFERS.length > 1">

                                </div> -->

                            <div class="eh-fast-order">
                                <!-- <a class="de-last-incart" href="">

                                </a> -->
                                <div class="delivery-list">
                                    <!-- Доставка:  -->
                                    <b v-if="item.PROPS.DELIVERY">{{item.PROPS.DELIVERY[0].VALUE_TEXT}}</b>
                                </div>
                                <div class="flex-ord-cart">
                                    <div>
                                        <a class="one-click-order feed-back-call-b" v-if="!item.BASKET" @click.stop.prevent="addToBasket(item)">
                                         Купить
                                        </a>
                                        <a class="one-click-order feed-back-call-b" href="/personal/cart/" v-if="item.BASKET" :class="{active: item.BASKET}" > 
                                            В корзину
                                        </a>
                                    </div>
                                   
                                    <div class="eh-like-t">
                                        <a class="eh-like-e" v-if="!item.FAVORITE" href="" @click.stop.prevent="addToFavorite(item)"> 
                                            <!-- <span>В избранное</span>  -->
                                        </a>
                                        <a class="eh-like-f" v-if="item.FAVORITE" href="/favorite/" :class="{active: item.FAVORITE}"> 
                                            <!-- <span>Перейти в избранное</span>  -->
                                        </a>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
        </div>
    </div> 
</template>